export const HOPLINK = "https://740323g7-aek1xf5u3trtcwn47.hop.clickbank.net";
export const PRODUCTS = {
  "joint-genesis": { name: "Joint Genesis", hoplink: HOPLINK, path: "/joint-genesis" },
  prostavive: { name: "ProstaVive", hoplink: "https://26fbd-lfrf0w2p6nwk32865xa4.hop.clickbank.net/", path: "/prostavive" },
  "nitric-boost": { name: "Nitric Boost", hoplink: "https://75b1e4hb-l8m5n4g03xmunfn0t.hop.clickbank.net", path: "/nitric-boost" },
};
export const EASE = [0.16, 1, 0.3, 1];
export const IMG = {
  hero: "https://images.unsplash.com/photo-1755692562119-94cc1e607ac9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  couple: "https://images.unsplash.com/photo-1647913097114-5975d965a1ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  beach: "https://images.unsplash.com/photo-1747302653826-42c6cd7295f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dance: "https://images.unsplash.com/photo-1758686254555-9bcaba0dd46d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bottle: "https://images.unsplash.com/photo-1700104494908-a08588182134?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  capsules: "https://images.unsplash.com/photo-1664786908163-85ca46f85138?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  prostaHero: "https://images.unsplash.com/photo-1788055650503-84b6361002d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  nitricHero: "https://images.unsplash.com/photo-1576913105965-1d0b6a19a482?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};
